import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../dialog-confirmation/dialog.confirmation.component';
import jwt_decode from 'jwt-decode';
import { NgForm } from '@angular/forms';
import { AdminService } from 'src/admin/services/admin.service';

@Component({
  selector: 'dialog-resetPassword-component',
  templateUrl: './dialog.resetPassword.component.html',
  styleUrls: ['./dialog.resetPassword.component.css'],
  providers: [AdminService]
})
export class ResetPasswordDialogComponent implements OnInit {

  sendFlag: boolean = false;
  newPassword: string = null;
  private user_info_obj: { name: string, role: string } = null;
  @ViewChild('f') resetPasswordForm: NgForm;

  constructor(private _snackBar: MatSnackBar,
    private loggerService: LoggerService,
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private adminService: AdminService) {
  }

  ngOnInit(): void {
    if (!this.user_info_obj) { this.user_info_obj = jwt_decode(localStorage.getItem('accessToken')); }
  }

  onSubmit() {
    this.sendFlag = true;
    // if (this.resetPasswordForm.valid) {
    //   this.adminService.updatePasswordByToken(this.newPassword).subscribe(res => {
    //     this.sendFlag = false;
    //     this.openSnackBar(res["message"], "Success");
    //     this.data.response = true;
    //     this.dialogRef.close(this.data.response);
    //   }, err => {
    //     this.sendFlag = false;
    //     this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
    //   })
    // }
  }




  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  onNoClick(): void {
    this.data.response = false;
    this.dialogRef.close(this.data.response);
  }
  onYesClick(): void {
    this.data.response = true;
    this.dialogRef.close(this.data.response);
  }


}
